import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      question: 'How does iSell.car determine my car\'s value?',
      answer: 'We use advanced AI technology combined with real-time market data, vehicle history, condition assessment, and current demand trends. Our system analyzes thousands of data points to provide you with a competitive and accurate valuation that often exceeds traditional dealership offers.'
    },
    {
      question: 'Is the pickup service really free?',
      answer: 'Yes, absolutely! We provide free pickup service anywhere in the United States. Our professional team will come to your location at your convenience, handle all paperwork, conduct the final inspection, and complete the transaction on the spot.'
    },
    {
      question: 'How quickly will I receive payment?',
      answer: 'Payment is processed immediately upon vehicle pickup and final inspection. You can choose to receive payment via instant bank transfer, certified check, or cash. Most customers receive their funds within minutes of completing the transaction.'
    },
    {
      question: 'What if I don\'t like the offers I receive?',
      answer: 'There\'s absolutely no obligation to sell. You can review all offers, compare them with other options, and decide what works best for you. If you\'re not satisfied with any offer, you can simply decline without any fees or commitments.'
    },
    {
      question: 'Do you buy cars with mechanical issues or accidents?',
      answer: 'Yes, we buy vehicles in all conditions! Whether your car has mechanical issues, accident damage, high mileage, or other concerns, we can still provide you with a competitive offer. Just be honest about the condition during the upload process.'
    },
    {
      question: 'What documents do I need to sell my car?',
      answer: 'You\'ll need your vehicle title (or lienholder information), a valid government-issued ID, and any maintenance records if available. Our team will help you with all paperwork and ensure everything is properly transferred.'
    },
    {
      question: 'Can I sell a car that I still owe money on?',
      answer: 'Absolutely! We handle financed vehicles all the time. We can work directly with your lender to pay off the loan and handle the title transfer. If you owe less than our offer, you\'ll receive the difference.'
    },
    {
      question: 'Is my personal information secure?',
      answer: 'Your privacy and security are our top priorities. We use bank-level SSL encryption to protect your personal information and never share your data with third parties without your explicit consent. All transactions are fully insured and guaranteed.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Got questions? We've got answers. Here are the most common questions about selling your car with iSell.car.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border border-border overflow-hidden hover:shadow-md transition-shadow duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="text-lg font-semibold text-foreground pr-4">
                  {faq.question}
                </h3>
                <div className={`flex-shrink-0 transform transition-transform duration-300 ${
                  openFAQ === index ? 'rotate-180' : ''
                }`}>
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" />
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-6 pb-6">
                  <p className="text-muted-foreground leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Help Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 border border-blue-100">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                <Icon name="HelpCircle" size={24} color="white" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              Still Have Questions?
            </h3>
            <p className="text-muted-foreground mb-6">
              Our customer support team is here to help you 24/7. Get in touch with us through any of these channels.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Phone" size={16} className="text-blue-600" />
                <span>Call: (555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Mail" size={16} className="text-green-600" />
                <span>Email: support@isell.car</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="MessageCircle" size={16} className="text-purple-600" />
                <span>Live Chat Available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;